import React from "react";
import Select from "react-select";

const DropDown = ({
  isMulti,
  value, // This is the ID (number)
  placeholder,
  onChange,
  id,
  onTouched,
  options = [],
  disabled,
  defaultValue,
}) => {
  // Convert value (ID) to an object from options
  const selectedOption = isMulti
    ? options.filter(option => value?.includes(option.id)) // For multi-select (array of IDs)
    : options.find(option => option.id === value) || null; // For single-select (single ID)

  // const selectedOption = isMulti
  // ? options.filter(option => value?.includes(option.id))
  // : isLabel
  // ? options.filter(option => value?.includes(option.EntityName))
  // : options.find(option => option.id === value) || null;

  const handleChange = (selectedOption) => {
    // Convert selected option object(s) to just their value(s)
    if (isMulti) {
      onChange(selectedOption ? selectedOption.map(opt => opt.id) : []);
    }else {
      onChange(selectedOption ? selectedOption.id : null);
    }
  };

  return (
    <Select
      isMulti={isMulti}
      id={id}
      value={selectedOption} // Pass the converted object
      onChange={handleChange}
      onBlur={onTouched}
      options={options}
      isDisabled={disabled}
      placeholder={placeholder}
      defaultValue={defaultValue}
      getOptionLabel={(e) => e.Label} // Ensure correct key
      getOptionValue={(e) => e.id} // Ensure correct key
      styles={{
        control: (provided) => ({
          ...provided,
          backgroundColor: disabled ? "#e0e0e0" : "white",
          border: "1px solid #ccc",
          borderRadius: "5px",
          minWidth: "100%",
          width: "100%",
          color: "#212129", // Ensure text color applies in the main input
        }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isSelected ? "#212129" : provided.backgroundColor,
          color: state.isSelected ? "white" : "#212129", // Ensure proper text color in dropdown
          fontWeight: "normal",
          "&:hover": {
            backgroundColor: "#212129",
            color: "white",
          },
        }),
        singleValue: (provided) => ({
          ...provided,
          color: "#212129", // Ensures selected value text color
        }),
        placeholder: (provided) => ({
          ...provided,
          color: "#212129", // Style placeholder text
        }),
      }}
    />
  );
};

export default DropDown;
